<template>
  <div>
    <div class="card card-body p-0" id="card_body" style="border-radius: 10px">
      <task-filter :developers="developers" :orgList="orgList" @setPage="setPage" @selectedTaskTab="selTab"
                   @skeletonLoader="setSkeletonLoader" :departments="departments"
                   @update-parent-filters="updateParentFilters"></task-filter>
      <task-table :developers="developers" :orgList="orgList" :totalPages="totalPages" :totalRows="totalRows"
                  :page="page" @setPage="setPage" :tasks="tasks" :setSkeletonLoader="displayLoader" :selTab="status"
                  :departments="departments"
                  @update-sortingby-variable="updateSortingByVariable"></task-table>
    </div>
  </div>
</template>
<script>
import helpers from "@/helpers.js";
import taskTable from './table';
import taskFilter from './filter';
import axios from 'axios';

export default {
  data: function () {
    return {
      orgList: [],
      page: 0,
      displayLoader: true,
      status: 0,
      developers: [],
      filters: this.$store.getters['tasks/filters'],
      sortingBy: {}
    };
  },
  components: {
    taskFilter, taskTable,
  },
  computed: {
    tasks: function () {
      return this.$store.getters['tasks/tasks'];
    },
    totalPages: function () {
      return this.$store.getters["tasks/totalPages"];
    },
    totalRows: function () {
      return this.$store.getters["tasks/totalRows"];
    },
    departments: function () {
      return this.$store.getters["tasks/department"];
    },
    // filters: function () {
    //     return this.$store.getters['tasks/filters'];
    // },
  },
  created: function () {
    this.page = helpers.getPageQuery();
    this.get_organizations();
    this.getDevelopersList();
    this.getDepartmentsList();

  },
  watch: {
    page: function (val) {
      this.setSkeletonLoader(true);
      this.filters.task_type = '';
      this.$store.dispatch("tasks/getAll", [val, this.filters, this.sortingBy])
          .then(() => {
            this.setSkeletonLoader(false);
          });
    },
  },
  methods: {
    setPage(page) {
      this.page = page;
      if (this.$route.query.page != 1) {
        this.$router.push("development-tasks?page=" + page);
      }
    },
    get_organizations() {
      axios.get("/admin/users/get-all-organizations?product=" + this.product).then((response) => {
        this.orgList = response.data;
      });
    },
    getDevelopersList() {
      this.$store.dispatch("users/getUserList", ['developer'])
          .then((res) => {
            this.developers = res.map(({id, full_name}) => ({id, full_name}));
          });
    },
    getDepartmentsList() {
      this.$store.dispatch("tasks/getDepartmentList");
    },
    setSkeletonLoader(val) {
      this.displayLoader = val;
    },
    selTab(event) {
      this.status = event;
    },
    updateParentFilters: function (value) {
      this.filters = value;
    },
    updateSortingByVariable: function (value) {
      this.sortingBy = value;
    },
    getRecords() {
      this.skeletonLoader = true;
      this.$store.dispatch("tasks/getAll", [1, this.filters, this.sortingBy]).then(() => {
        this.skeletonLoader = false;
      });
    },
  }
}
</script>
<style scoped lang="scss">
.new_contract {
  border: 1px solid rgb(72, 166, 166) !important;
  background: rgb(72, 166, 166);
  color: white;

  &:hover {
    background-color: #f0ed00;
    color: rgb(72, 166, 166) !important;
    background: white !important;
  }
}
</style>